import { getSiteUiCopy } from "@/lib/site-ui-copy";
import { DEFAULT_LANG } from "@/lib/constants";
/**
 * Nav/footer theme bands compare **logical** English paths (`/services`, `/about`, …).
 * Locale-prefixed URLs are normalized via {@link toLogicalPathname} before checks.
 */
import { SERVICE_DARK_HERO_PATHS } from "@/lib/cc-nav-route-constants";
import { heroUsesDarkNav } from "@/lib/hero-theme";
import { isKnownSitePath, normalizeLogicalPathname } from "@/lib/cc-site-paths";

export {
  CLOSING_BAND_PATHS,
  CC_OVERVIEW_ATTACHED_LOGICAL_PATHS,
  SERVICE_DARK_HERO_PATHS,
} from "@/lib/cc-nav-route-constants";
export { isKnownSitePath } from "@/lib/cc-site-paths";
export { footerContinuesClosingBand, footerUsesAntiquePhoto } from "@/lib/cc-footer-layout";

function normalize(pathname: string): string {
  return normalizeLogicalPathname(pathname);
}

/**
 * SSR / first-paint nav theme: true when the viewport top sits over a dark hero or band.
 * Unknown routes render `not-found` with a full-viewport dark frame.
 */
export function navHasDarkHero(pathname: string, homeHasDarkHero: boolean): boolean {
  const path = normalize(pathname);

  if (!isKnownSitePath(pathname)) {
    return true;
  }

  if (path === "/") {
    return homeHasDarkHero;
  }

  if (SERVICE_DARK_HERO_PATHS.some((p) => path === p)) {
    return heroUsesDarkNav();
  }

  if (path === "/projects" || path === "/services" || path === "/blog") {
    return true;
  }

  if (path === "/contact") {
    return false;
  }

  if (path === "/privacy-policy" || path === "/about") {
    return false;
  }

  if (path.startsWith("/projects/") || path.startsWith("/blog/")) {
    return false;
  }

  return false;
}

export function navCtaLabel(
  pathname: string,
  homeCtaLabel: string,
  bookCallLabel = getSiteUiCopy(DEFAULT_LANG).bookCall,
  seoBookCallLabel?: string,
): string {
  const path = normalize(pathname);

  if (path === "/seo" && seoBookCallLabel) {
    return seoBookCallLabel;
  }

  if (SERVICE_DARK_HERO_PATHS.some((p) => path === p)) {
    return homeCtaLabel;
  }

  if (path === "/about" || path === "/contact") {
    return bookCallLabel;
  }

  return homeCtaLabel;
}
